const AppConfig = {
    "SERVICE_AGREEMENT_URL": process.env.REACT_APP_SERVICE_AGREEMENT_URL,
    "ASWAR_ADMINISTRATION_URL": process.env.REACT_APP_ASWAR_ADMINISTRATION_URL,
    "ASWAR_DOCUMENTATION_URL": process.env.REACT_APP_ASWAR_DOCUMENTATION_URL,
    "FILE_AN_ISSUE": process.env.REACT_APP_FILE_AN_ISSUE,
    "SOFTWARE_VERSION": "2.1.5",
    "CLOUD_COMMIT_WEBSITE_URL": process.env.REACT_APP_CLOUD_COMMIT_WEBSITE_URL,
    "DEFAULT_HOSTED_ZONE_ID": process.env.REACT_APP_DEFAULT_HOSTED_ZONE_ID,
    "APP_NAME": "Aswar Menu"
}
export default AppConfig;